import React from "react";
import "./Home.css";
import bg from "../../assets/image.png";
import btnImg from "../../assets/hireme.png";
import { ReactTyped as Typed } from "react-typed"; 
import { motion } from "framer-motion";

const Home = () => {
  // Variants for animations
  const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.3 } } };
  const textVariants = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } } };
  const btnVariants = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } } };
  const imageVariants = { hidden: { opacity: 0, x: 200, scale: 0.9 }, visible: { opacity: 1, x: 0, scale: 1, transition: { duration: 1, ease: "easeOut" } } };

  return (
    <section id="home">

      <motion.div
        className="homeContent"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
      >
        {/* Welcome Text */}
        <motion.span
          className="welcome-text"
          variants={textVariants}
        >
          Welcome!
        </motion.span>

        {/* Name & Typed Text */}
        <motion.span className="homeText" variants={textVariants}>
          I'm <span className="homeName">Lokesh Lanka,</span> <br />
          a{" "}
          <Typed
            strings={[
              "Full-Stack",
              "React JS",
              "JavaScript",
              "Front-End",
              "Node JS",
              "Back-End",
            ]}
            typeSpeed={70}
            backSpeed={50}
            backDelay={1500}
            loop
          />{" "}
          Developer.
        </motion.span>

        {/* Portfolio Paragraph */}
        <motion.p className="homePara" variants={textVariants}>
          This is my Portfolio website to showcase all about my Profile.
        </motion.p>

        {/* Hire Me Button */}
        <motion.a
          href="#contact"
          className="homeBtn"
          variants={btnVariants}
          whileHover={{ scale: 1.1, rotate: 2 }}
          whileTap={{ scale: 0.95 }}
        >
          <img src={btnImg} alt="Hire Me" className="btnImg" />
          Hire Me
        </motion.a>
      </motion.div>

      {/* Profile Image */}
      <motion.img
        src={bg}
        alt="profile"
        className="bg"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={imageVariants}
        whileHover={{ scale: 1.05, rotate: 1 }}
      />
    </section>
  );
};

export default Home;
